import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/ui-components/icon/icon.component';
import { CustomLinkDirective } from '@shared/directives/custom-link/custom-link.directive';
import { AcRoutingService } from '@core/services/routing/ac-routing.service';
import { Footer } from '@shared/constants/footer';

@Component({
  selector: 'ac-legal-links',
  standalone: true,
  imports: [IconComponent, TranslateModule, RouterLink, NgTemplateOutlet, CustomLinkDirective],
  templateUrl: './legal-links.component.html',
  styleUrls: ['./legal-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalLinksComponent {
  cookiesRoute = AcRoutingService.COOKIES_ROUTE();
  privacyRoute = AcRoutingService.PRIVACY_ROUTE();
  legalRoute = AcRoutingService.LEGAL_ROUTE();
  ethical_channel = Footer.ETHICAL_CHANNEL;
}
